import "./BuildingItem.less";
import {TexturedShopItem, TexuredShopItemProps} from "@game/ui/components/Shop/TexturedShopItem";

export const BuildingItem = ({
    textureUrl = "",
    playerColor = undefined,
    className = ""
}: TexuredShopItemProps) => (
    <div className={"shop-item-building"}>
        <TexturedShopItem textureUrl={textureUrl} className={className} playerColor={playerColor} />
    </div>
);
